import { c as _c } from "react/compiler-runtime";
import { UserMoreInfoMenuItem } from "@components/user-more-info-menu/user-more-info-menu-item";
import { UserMoreInfoMenuProfileButton } from "@components/user-more-info-menu/user-more-info-menu-profile-button";
import { UserMoreInfoMenuTitle } from "@components/user-more-info-menu/user-more-info-menu-title";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { Box } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { Divider, RoleIcon } from "@flat-ui";
import { CommonStyles } from "@styles/common-styles";
import { formatUserRoleType } from "@utils/data-display";
/** Width in pixels for the menu */
export const MENU_WIDTH = "262px";

/**
 * Component that shows the menu when the user hovers over a member to see a quick
 * overlook about the user and open the profile page.
 */
export function UserMoreInfoMenu(t0) {
  const $ = _c(17);
  const {
    member
  } = t0;
  const currentUser = useAppSelector(currentUserSelector);
  const isCurrentUser = member?.identity === currentUser?.identity;
  const hasRoleProperty = member && "role" in member;
  const t1 = member?.id;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      memberId: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    canViewCompanyMemberProfile
  } = useHasUserValidRoleCompanyLevel(t2);
  if (!member) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <></>;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: MENU_WIDTH,
      border: CommonStyles.Borders.divider
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isCurrentUser || $[5] !== member) {
    t4 = <UserMoreInfoMenuTitle member={member} isCurrentUser={isCurrentUser} />;
    $[4] = isCurrentUser;
    $[5] = member;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== hasRoleProperty || $[8] !== member) {
    t5 = hasRoleProperty && <Box component="div"><UserMoreInfoMenuItem text={formatUserRoleType(member.role)} icon={RoleIcon} /></Box>;
    $[7] = hasRoleProperty;
    $[8] = member;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== canViewCompanyMemberProfile || $[11] !== member) {
    t6 = canViewCompanyMemberProfile && <><Divider sx={{
        marginX: "8px"
      }} /><UserMoreInfoMenuProfileButton member={member} /></>;
    $[10] = canViewCompanyMemberProfile;
    $[11] = member;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <Box component="div" sx={t3}>{t4}{t5}{t6}</Box>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}